export const getCurrentView = (
    tenantType: string,
    partnerId: number,
    tenantId: number
  ): "GLOBAL_ADMIN" | "PARTNER" | "CUSTOMER" => {
    if (tenantType === "GLOBAL_ADMIN") {
      if (partnerId && tenantId && partnerId !== tenantId) return "CUSTOMER";
      if (partnerId) return "PARTNER";
      return "GLOBAL_ADMIN";
    }
    if (tenantType === "PARTNER") {
      return partnerId !== tenantId ? "CUSTOMER" : "PARTNER";
    }
    return "CUSTOMER";
  };
  